import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'store';
import { selectUser } from 'store/user';
import { isHipaaLink } from 'config/productProfile';
import { MediaContainer } from 'components';
import { ProviderRoomPage } from 'pages';
import { VIA3HomePage } from 'pages/VIA3HomePage';
import { FaxProvider } from 'context';
import { SECOND_ACCOUNT_PAYMENT_REQUIRED } from 'constants/index';
import { getIsAdminByRoles } from 'utils';

export default function RootLandingResolver() {
  const user = useAppSelector(selectUser);
  const secondAccountPaymentRequired = localStorage.getItem(SECOND_ACCOUNT_PAYMENT_REQUIRED) === 'true';
  const isUnpaidSecondAccountCandidate =
    !!user &&
    getIsAdminByRoles(user.clinicUser.roles || []) &&
    user.clinicUser.createRoomSkipped &&
    !user.clinicUser.subscriptionInfo &&
    user.clinicUser.via3UserType !== 'Member';
  const shouldEnforceSecondAccountFlow = secondAccountPaymentRequired && isUnpaidSecondAccountCandidate;

  // HIPAA LINK
  if (isHipaaLink) {
    if (user) {
      if (shouldEnforceSecondAccountFlow || isUnpaidSecondAccountCandidate) {
        return <Navigate to='/registerSecondAccount' replace />;
      }
      return (
        <MediaContainer>
          <ProviderRoomPage />
        </MediaContainer>
      );
    }

    return <Navigate to='/login' replace />;
  }

  // VIA3 logged in
  if (user) {
    if (shouldEnforceSecondAccountFlow || isUnpaidSecondAccountCandidate) {
      return <Navigate to='/registerSecondAccount' replace />;
    }
    return (
      <FaxProvider>
        <MediaContainer>
          <ProviderRoomPage />
        </MediaContainer>
      </FaxProvider>
    );
  }

  // VIA3 public landing
  return <VIA3HomePage />;
}
